import { LOGIN_VERSION } from '../utils/config';

export default class LoginBase {
  constructor({ source = '' } = {}) {
    this._initialized = false;
    this._callbacks = [];
    this.VERSION = LOGIN_VERSION;
    this.source = source;
  }
  /**
   * @param {function} callback
   * @returns {Promise}
   */
  init(callback) {
    this.onInit(callback);
    return Promise.resolve();
  }
  ready() {
    this._callbacks.forEach(fn => fn());
    this._callbacks = [];
    this._initialized = true;
  }
  onInit(callback) {
    if (typeof callback === 'function') {
      if (this._initialized) {
        callback && callback();
      } else {
        this._callbacks.push(callback);
      }
    }
  }
  setConfig() {}
  isLogin() {}
  isStrictLogin() {}
  isPTLogin() {}
  isQQLogin() {}
  isWXLogin() {}
  isPhoneLogin() {}
  isNewQQLogin() {}
  isFamilyChildLogin() {}
  loginType() {}
  openLogin() {}
  logout() {}
  checkUser() {}
  checkFamilyChildLogin() {}
  getMainUserInfo() {}
  getMainCookie() {}
  getUin() {}
  getUid() {}
  getVuid() {}
  getToken() {}
  buildCSRF() {}
}
